import React from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  classes?: string;
  className?: string;
  currentSlide?: number;
  slideCount?: number;
  ariaLabel?: string;
};

export const NavigationButton = (props: Props) => {
  const newProps = { ...props };

  newProps.className = cx('arrows', newProps.classes, newProps.className);

  delete newProps.currentSlide;
  delete newProps.slideCount;
  delete newProps.classes;
  delete newProps.ariaLabel;

  return <Button {...newProps} aria-label={props.ariaLabel} type="button" />;
};

const Button = styled.button`
  border: 0 none;
  border-radius: 4px;
  height: 28px;
  top: -40px;
  width: 28px;
  z-index: 1;
`;
